import { AfterContentInit, Component } from '@angular/core';

import { UserService } from '@/app/services/user.service';
import { Router, RouterLink } from '@angular/router';
import { MatAnchor } from '@angular/material/button';
import {
  MatCard,
  MatCardContent,
  MatCardHeader,
  MatCardFooter,
  MatCardImage,
  MatCardActions,
} from '@angular/material/card';
import { NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'page-landing',
  imports: [
    MatAnchor,
    MatCard,
    MatCardContent,
    MatCardHeader,
    MatCardFooter,
    MatCardActions,
    MatCardImage,
    NgOptimizedImage,
    RouterLink,
  ],
  templateUrl: './landing.component.html',
  styleUrl: './landing.component.scss',
})
export class LandingComponent implements AfterContentInit {
  public hideBannerWidget = false;
  public hideDisclaimer = false;
  public year = new Date().getFullYear();

  constructor(
    protected router: Router,
    protected userService: UserService,
  ) {}

  ngAfterContentInit(): void {
    this.hideBannerWidget = true;
  }

  public handleLoginClick(evnt: MouseEvent | KeyboardEvent) {
    if (evnt.altKey) {
      this.router.navigate(['/login'], { queryParams: { firstech: true } });
    } else {
      this.userService.login();
    }
  }
}
